import { ServicesInit, api } from "@TaankYou/services";
import { GetAuthorizationHeader, IsLogged, SignOut } from "@TaankYou/auth";

import { InvoiceV2Service as InvoiceV2S } from "./InvoiceV2/service";

import { NotificationManager } from "react-notifications";
import Variables from "../Utils/Variables";

const IS_MOCKED = false;

let InvoiceV2Service;

if(!api){
    const UNAUTH_SUBCODE = "AuthUnauthorized"; 

    ServicesInit({
        apiBaseUrl: Variables.api.replace("/v2", ""),
        onError: e => {
            if(e.subcode === UNAUTH_SUBCODE)
                SignOut(window.location.toString());
        },
        notifyError: ({desc}) => NotificationManager.error(desc)
    });

    if(IsLogged())
        api.AddHeader("Authorization", GetAuthorizationHeader());

    api.AddHeader("X-Language", "fr");
    api.AddHeader("X-Application-Id", "dashboard");
    api.AddHeader("X-For-Business", "1");
}

if(IS_MOCKED){
    InvoiceV2Service = new InvoiceV2S();
}
else {
    InvoiceV2Service = new InvoiceV2S();
}

export {
    InvoiceV2Service
};



// WEBPACK FOOTER //
// ./src/services/index.js